import { useTypedSelector } from "~/hooks/useTypedSelector";

export const useHelpLinkOverride = () => {
  const customOverrides = useTypedSelector((state) => state.customOverrides);
  const userOverrides = customOverrides?.overrides;
  return userOverrides?.helpLink;
};
